module.exports = __webpack_public_path__ + "img/20210630.bb4d6acf.png";